module.exports = __webpack_public_path__ + "../static/img/avatar-4.e0ab315a.jpg";